/* esm.sh - @radix-ui/react-popover@1.1.15 */
export * from "/*@radix-ui/react-popover@1.1.15/esnext/react-popover.mjs";
